import React, { useCallback } from "react";
import clsx from "clsx";
import Icon from "../minicart/icon";
import { OVERLAYS } from "./const";

export default function MonogramHeader({ mobileOnly, desktopOnly, overlay, handleCloseAttempt }) {
  const renderHeaderTextOrLogo = useCallback(() => {
    if (overlay === OVERLAYS.Exit) return <h1 className="monogram__header-title">Are You Sure?</h1>;

    if (overlay === OVERLAYS.WhatFits)
      return <h1 className="monogram__header-title">What Fits?</h1>;

    // if (logo) {
    //   return <img src={logo} className="monogram__header-logo" alt="Logo for Stoney Clover Lane" />;
    // }

    return (
      <button type="button" onClick={handleBack} className="monogram__header-logo-wrapper">
        <Icon id="arrow" /> <span>Return to Style Selection</span>
      </button>
    );
  });

  function handleBack() {
    if (document.referrer.includes("/products") && document.referrer.includes("?view=monogram")) {
      // create a new URL object
      const url = new URL(document.referrer);

      // get the URL search parameters
      const searchParams = new URLSearchParams(url.search);

      // remove the 'view' parameter
      searchParams.delete("view");

      // create a new URL with the updated search parameters
      const newUrl = `${url.origin}${url.pathname}?${searchParams.toString()}`;
      window.location.href = newUrl;
      return;
    }

    if (!document.referrer.includes("/products") || !document.referrer.includes("/collections")) {
      window.location.href = "/collections/customize";
      return;
    }

    window.history.back();
  }

  return (
    <div
      className={clsx("monogram__header", {
        "monogram__header--mobile-only": mobileOnly,
        "monogram__header--desktop-only": desktopOnly,
      })}
    >
      {renderHeaderTextOrLogo()}
      <button
        className="monogram__header-close"
        onClick={handleCloseAttempt}
        value="Click to close embroidery options on product"
        aria-label="Close Embroidery Options"
      >
        <Icon id="x" />
      </button>
    </div>
  );
}
